import React, { useEffect, useState } from "react";
import Map from "./components/map";
import { useTranslation } from "react-i18next";

const Distributors = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [distributors, setDistributors] = useState(null);
  const [coordenates, setCoordenates] = useState(null);

  useEffect(() => {
    props.getDistributors().then((r) => {
      setCoordenates(
        r.map((m) => ({
          lat: parseFloat(m.lat),
          lng: parseFloat(m.lng),
          country: m.country,
        }))
      );

      setDistributors(
        r.map((m, i) => {
          return (
            <tr key={i}>
              <td>{m.country}</td>
              <td>{m.person}</td>
              <td>
                {m.address1} - {m.address2} - {m.city}
              </td>
              <td>{m.email}</td>
              <td>{m.comments}</td>
            </tr>
          );
        })
      );
      setIsLoading(false);
    });
  }, []);

  const distributorTable = !isLoading ? (
    <div className="table-responsive">
      <Map coordenates={coordenates} />
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{t("country")}</th>
            <th>{t("distributor")}</th>
            <th>{t("address")}</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{distributors}</tbody>
      </table>
    </div>
  ) : null;
  return (
    <div className="container text-relevant text-justify">
      <h1>{t("how-to-order")}</h1>

      <h3>{t("international") + " " + t("distributors")}</h3>
      {distributorTable}

      <h3>{t("north-america")}</h3>
      <div className="row">
        <div className="col-md-8">
          <p dangerouslySetInnerHTML={{ __html: t("distributors-p1") }}></p>
          <p>{t("procedure")}</p>
          <ul>
            <li>{t("distributors-p2")}</li>
            <li>{t("distributors-p3")}</li>
            <li>{t("distributors-p4")}</li>
            <li>{t("distributors-p5")}</li>
            <li>{t("distributors-p6")}</li>
            <li>{t("distributors-p7")}</li>
          </ul>
        </div>
        <div className="col col-md-4">
          <div className="card" style={{ maxWidth: "250px" }}>
            <div className="card-header">Chapel Library U.S.</div>
            <div className="card-body">
              <p>2603 West Wright St.</p>
              <p>Pensacola, Florida 32505</p>
              <p>fax: (850) 438-0227 </p>
              <p>
                <a href="mailto:chapel@mountzion.org">
                  <em>chapel@mountzion.org</em>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Distributors;
